import { type ReactNode } from 'react';
import { ArchiveRestore, Camera, Palmtree, Pencil } from 'lucide-react';
import { AdvancedActions } from './approacher-actions-advanced';

const ITEM =
  'inline-flex min-h-[36px] items-center gap-1.5 rounded-md px-sm py-1.5 text-xs text-text-secondary transition-colors hover:bg-surface-elevated hover:text-text-primary';

type ViewProps = {
  onEdit: () => void;
  onArchive: () => void;
  onReset: () => void;
  onStreakReset: () => void;
  onUploadPhoto?: () => void;
  onVacation?: () => void;
};

function PrimaryRow({
  onEdit,
  onUploadPhoto,
  onVacation,
}: Pick<ViewProps, 'onEdit' | 'onUploadPhoto' | 'onVacation'>): ReactNode {
  return (
    <div className="flex flex-wrap items-center gap-xs">
      <button onClick={onEdit} className={ITEM}>
        <Pencil size={13} /> Editar
      </button>
      {onUploadPhoto && (
        <button onClick={onUploadPhoto} className={ITEM}>
          <Camera size={13} /> Foto
        </button>
      )}
      {onVacation && (
        <button onClick={onVacation} className={ITEM}>
          <Palmtree size={13} /> Vacaciones
        </button>
      )}
    </div>
  );
}

export function ViewActions(p: ViewProps): ReactNode {
  return (
    <div className="space-y-md border-t border-white/[0.06] pt-base">
      <PrimaryRow {...p} />
      <AdvancedActions
        onReset={p.onReset}
        onStreakReset={p.onStreakReset}
        onArchive={p.onArchive}
      />
    </div>
  );
}

export function ArchivedActions({
  onRestore,
}: {
  onRestore: () => void;
}): ReactNode {
  return (
    <div className="flex items-center justify-end border-t border-white/[0.06] pt-base">
      <button onClick={onRestore} className={ITEM}>
        <ArchiveRestore size={13} /> Restaurar
      </button>
    </div>
  );
}
